import { useCallback } from "react";

/**
 * Custom hook to manage SEO metadata (title, description, image) using the global window.setSiteSEO function.
 * @returns {Object} An object containing the setSEO function.
 */
export const useSEO = () => {
  const setSEO = useCallback((title, description = "", imageUrl = "") => {
    if (window.setSiteSEO) {
      window.setSiteSEO(title, description, imageUrl);
    } else {
      console.warn("window.setSiteSEO is not defined. Ensure _FrontLayout.cshtml is correctly loaded.");
      // Fallback for document title at least
      if (title) document.title = title;
    }
  }, []);

  return { setSEO };
};

export default useSEO;
